import React, { useDebugValue, useEffect, useState } from "react";
import { Form, Image } from "react-bootstrap";
import { INDUSTRY_ENUM_CATEGORY, INDUSTRY_ENUM, CATEGORY } from "../config/const";
import { Facility, OpportunityStructure } from "../types/type";
import { formatNumber } from '../utils/utils';

const DetailFacility: React.FC<{ facility: Facility, company: OpportunityStructure, isOpen: boolean, onToggle: any }> = ({ facility, company, isOpen, onToggle }) => {

    const [helpActive, setHelpActive] = useState(false);
    const [extraHighVoltage, setExtraHighVoltage] = useState(false);
    const [meteredRate, setMeteredRateVoltage] = useState(false);

    useEffect(() => {
        setExtraHighVoltage(facility.category === 1);  // 高圧
        setMeteredRateVoltage(facility.category === 4); // 従量電灯
    }, [facility.category]);


    return (
        <>
            <div id={`table_75`} className="table-demo-header mt-4 mx-4 p-3 bg-green-03">
                <div className="row mx-0 fw-300">
                    <div className="my-auto col-1 pe-2">
                        <div className="mb-sm-0 mb-3">
                            <img
                                onClick={onToggle}
                                className={`img d-inline-block mb-sm-0 mb-2 me-2 action-class ${isOpen ? 'rotate-img-180' : ''}`} data-action={`action-class-wrapper-75`} src="assets/images/other/icon-up-arrow.svg" />
                        </div>
                    </div>
                    <div className="col px-0 my-auto table-right-wrapper">
                        <div className="bg-white p-2 mb-2">
                            <div className="row">
                                <div className="col-lg-4 col-sm-6 mb-md-0 mb-3 border-right-1">
                                    <div className="d-inline-block">
                                        <p className="mb-0 text-xsm text-ass-07">施設名</p>
                                        <p className="text-xs-2">{facility.name}</p>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 mb-md-0 mb-3 border-right-1">
                                    <div className="d-inline-block">
                                        <p className="mb-0 text-xsm text-ass-07">施設所在地</p>
                                        <p className="text-xs-2">{facility.address}</p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="d-inline-block">
                                        <p className="mb-0 text-xsm text-ass-07">供給地点番号</p>
                                        <p className="text-xs-2">{facility.contract_number}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-2 mb-2">
                            <div className="row">
                                <div className="col-12 pull-left">
                                    <span className="text-green">施設要望事項</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className={` text-center col border-right-1 py-auto padding-right-0`}>
                                    <div className="d-inline-block ">
                                        <span className="text-xsm">最低入札単価</span>
                                        <b><span className="text-sm ml-1 fw-300 ">{facility.min_bid_amount} </span>円（税込）</b>

                                        <div
                                            className={`icon-ask${helpActive ? ' active' : ''}`}
                                            id={`icon-ask-75`}
                                            data-id={`icon-ask-help-75`}
                                            onClick={() => setHelpActive(!helpActive)}
                                        >
                                            <div className="icon-ask-help" id="icon-ask-help-75" style={{ display: helpActive ? "block" : "none" }}>
                                                <h1>最低入札単価<div data-id="ask-help-75" className="ask close"><Image src="/assets/images/other/icon-close.svg" /></div>
                                                </h1>
                                                <p>入札単価で直近12か月間の電気使用実績に基づく使用量と、当社見積データベースを参照にした総合単価を　表示しています</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 border-right-1 text-center">
                                    <div className="d-inline-block">
                                        <span className="mx-auto"><span className="text-xsm">再生可能エネルギー</span>
                                            <span className="ml-1 pull-left">
                                                <Image className="img img-fluid" src={`assets/images/other/icon-eco-${facility.option_4 ? "blue" : "ass"}.svg`} />
                                            </span>
                                            {facility.option_4 ? "要望する" : "要望しない"}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-4 text-center">
                                    <div className="d-inline-block">
                                        <span className="text-xsm">希望供給開始日</span>
                                        <span className="ml-1 text-xs-2 pull-left">
                                            {facility.contract_start_date}

                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white bg-white py-2 mt-2">
                            <div className="row">
                                <div className={`${!extraHighVoltage ? "col-lg-6" : "col-lg-4"} col-sm-6 border-right-1 py-auto text-center`}>
                                    計量日
                                    <span className="text-sm fw-300 ml-3">{facility.measurement_day}日</span>
                                </div>

                                {!extraHighVoltage ? null : (
                                    <div className="col-lg-4 col-sm-6 border-right-1 py-auto text-center">
                                        供給電圧<span className="text-sm fw-300 ml-3">{facility.supply_voltage}kV</span>
                                    </div>
                                )}
                                <div className={`${!extraHighVoltage ? "col-lg-6" : "col-lg-4"} col-sm-6 border-right-1 py-auto text-center`}>
                                    希望プラン<span className=" text-xs-2 fw-300 ml-3">{facility.plan_type}</span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white bg-white py-2 mt-2">
                            <div className="row">
                                <div className="col-lg-3 col-sm-6 border-right-1 py-auto text-center">
                                    <span className="btn-secondary text-white px-2 mr-1" style={{ background: `${facility.category && CATEGORY[facility.category] ? CATEGORY[facility.category]["color"] : "#000000"}` }}>{facility.category && CATEGORY[facility.category] ? CATEGORY[facility.category]["name"] : ""}</span>
                                    <div className="bg-ass-04 text-white d-inline-block px-2 mb-3">{company.industry && INDUSTRY_ENUM_CATEGORY[company.industry] ? INDUSTRY_ENUM[INDUSTRY_ENUM_CATEGORY[company.industry]] : INDUSTRY_ENUM['UNCLASSIFIED']}</div>
                                </div>
                                <div className="col-lg-3 col-sm-6 border-right-1 py-auto text-center">
                                    年間使用量電力
                                    <span className="text-sm fw-300 ml-3">{formatNumber(facility.usage_total)}kWh</span>
                                </div>
                                <div className="col-lg-3 col-sm-6 border-right-1 py-auto text-center">
                                    {meteredRate ? '受電容量' : '契約電力'}<span className="text-sm fw-300 ml-3">{facility.contract_usage}
                                        {meteredRate ? 'kVA' : 'kW'}
                                    </span>
                                </div>
                                <div className="col-lg-3 col-sm-6 py-auto text-center">
                                    年負荷率<span className="text-sm fw-300 ml-3">{facility.annual_load_factor_p}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div id="show-eco-help-<?php e($rec->id); ?>" className="modal fade bd-example-modal-sm show-eco-help-modal-wrapper" tabIndex={-1} role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-sm show-eco-help-modal">
                    <button type="button" className="close upper-close" data-dismiss="modal" aria-label="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="modal-content ">
                        <div className="modal-header">
                            <h5 className="modal-title">再生可能エネルギーに関する要望</h5>
                        </div>
                        <div className="modal-body">
                            <ul className="">
                                <li>再生可能エネルギー比率<span className="large">50%以上</span></li>
                                <li>CO2削減率<span className="large">10％以上</span></li>
                                <li>トラッキング<span className="large">有り</span></li>
                            </ul>
                            <div className="note">
                                <span>備考欄</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DetailFacility;